export const SET_LIFE_PURCHASE_REQUEST = 'SET_LIFE_PURCHASE_REQUEST';
export const SET_LIFE_PURCHASE_SUCCESS = 'SET_LIFE_PURCHASE_SUCCESS';
export const SET_LIFE_PURCHASE_FAILURE = 'SET_LIFE_PURCHASE_FAILURE';
